// extracted by mini-css-extract-plugin
export var deliveryRow = "_sm-a";
export var fixedHeight = "_sm-4";
export var freightLogo = "_sm-9";
export var fullWidth = "_sm-3";
export var priceColumn = "_sm-5";
export var radioSelected = "_sm-7";
export var radioUnselected = "_sm-6";
export var selectedOption = "_sm-2";
export var selectedOptionContainer = "_sm-1";
export var selection = "_sm-0";
export var tallSkeletonText = "_sm-8";